import type { HelpFile } from '../../types/help'
import { InboundConnectorsTestIds } from '../../../testids/InboundConnectorsTestIds'

export const inboundConnectorsHelp: HelpFile = {
  docPage: '/docs/connectors/inbound',
  texts: {
    [InboundConnectorsTestIds.inboundConnectorsList]: 'Eingehende Konnektoren übernehmen Daten aus externen Systemen (HR, Verzeichnisse, IGA-Werkzeuge) und erstellen oder aktualisieren damit Parteien und Identitäten.',
    [InboundConnectorsTestIds.createInboundConnectorButton]: 'Neuen eingehenden Konnektor für ein Quellsystem anlegen.',
    [InboundConnectorsTestIds.inboundConnectorsTable]: 'Jede Zeile steht für einen Konnektor — der Status-Badge zeigt, ob er gerade synchronisiert, im Leerlauf ist oder einen Fehler hat.',
    [InboundConnectorsTestIds.colLastSync]: 'Letzter abgeschlossener Synchronisationslauf — Konnektor öffnen für die Lauf-Historie.',
    [InboundConnectorsTestIds.inboundConnectorsSkeleton]: null,
  },
}
